import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

interface CarouselProps {
  children: React.ReactNode[]
  footer?: React.ReactNode
  index: number
}

export const Carousel = ({ children, footer, index }: CarouselProps) => {
  return (
    <Box flexDirection="column" alignItems="center" position="relative">
      <Box width="full" overflowX="hidden" flexDirection="row" position="relative">
        {React.Children.map(children, (child, ind) => (
          <Box
            key={ind}
            minWidth="full"
            style={{
              transform: `translateX(-${index * 100}%)`,
              opacity: index === ind ? '1' : '0',
              transition: 'transform 0.5s ease-in-out, opacity 0.25s ease',
            }}
          >
            {child}
          </Box>
        ))}
      </Box>
      {footer ?? ''}
    </Box>
  )
}
